import {IStackStyles, IStackTokens, Label, Stack, StackItem, TextField} from "@fluentui/react";
import styles from "./InitiatorPoiFieldsComponent.module.css"
import strings from "../../../loc/strings";
import React from "react";
import {IInitiatorDetails} from "../../../model/InitiatorDetails";
import {RequestPOIInfoItem} from "../../../model/RequestPOIInfoItem";

const numericalSpacingStackTokens: IStackTokens = {
    childrenGap: 33,
    padding: 30,
};
const stackStyles: IStackStyles = {
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '40px'
    },
};
const stackStylesLabels: Partial<IStackStyles> = {
    root: {
        marginLeft: '0px',
        marginTop: '20px',
        marginBottom: '10px'
    },
};
interface poiProps {
    initiatorDetails: IInitiatorDetails,
    personOfInterest: RequestPOIInfoItem,
    poiTitle: string,
    isView: boolean
}
function InitiatorPoiFieldsComponent(props: poiProps) {
    const initiatorDetails = props.initiatorDetails;
    const personOfInterest = props.personOfInterest;
    const placeOfBirth =   personOfInterest?.CityOfBirth.trim() && personOfInterest?.CountryOfBirth.trim()
        ? `${personOfInterest?.CityOfBirth.trim()}, ${personOfInterest?.CountryOfBirth.trim()}`
        : personOfInterest?.CityOfBirth.trim() ? personOfInterest?.CityOfBirth.trim() : personOfInterest?.CountryOfBirth.trim() ? personOfInterest?.CountryOfBirth.trim() : '';
    const poiTitle = props.poiTitle;
    const isView = props.isView;

    return (
        <div>
            <StackItem styles={stackStylesLabels}>
                <Label className={styles.SmallHeader}>
                    {strings.requestForInfoInitiatorDetailsTitle}
                </Label>
            </StackItem>
            <Stack horizontal={true} horizontalAlign="start" styles={stackStyles} className={styles.ReadOnlyStack} wrap
                   tokens={numericalSpacingStackTokens}>
                    <StackItem className={styles.SearchStackItemFirstRow}>
                        <Label>{strings.requestForInfoNameLabel}</Label>
                        <TextField disabled={true} multiline autoAdjustHeight resizable={false} rows={1} styles={{ fieldGroup: { minHeight: 'unset' } }} value={[initiatorDetails?.name, initiatorDetails?.originatorName].filter(Boolean).join('\n')} />
                    </StackItem>
                    <StackItem className={styles.SearchStackItemFirstRow}>
                        <Label>{strings.requestForInfoUsernameLabel}</Label>
                        <TextField disabled={true} value={initiatorDetails?.userName} className={styles.DisabledTextField} />
                    </StackItem>
                    <StackItem className={styles.SearchStackItemFirstRow}>
                        <Label>{strings.requestForInfoEmailLabel}</Label>
                        <TextField disabled={true} multiline autoAdjustHeight resizable={false} rows={1} styles={{ fieldGroup: { minHeight: 'unset' } }} value={[initiatorDetails?.email].filter(Boolean).join('\n')} className={styles.DisabledTextField} />
                    </StackItem>`
                    <StackItem className={styles.SearchStackItemFirstRow}>
                        <Label>{strings.requestForInfoAuthorityNameLabel}</Label>
                        <TextField disabled={true} value={initiatorDetails?.authorityName} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemFirstRow}>
                        <Label>{strings.requestForInfoAuthorityCountryLabel}</Label>
                        <TextField disabled={true} value={initiatorDetails?.authorityCountry} className={styles.DisabledTextField}/>
                    </StackItem>
            </Stack>
            <StackItem styles={stackStylesLabels}>
                <Label className={styles.SmallHeader}>
                    {poiTitle}
                </Label>
            </StackItem>
            {personOfInterest?.PersonType === 'Legal' ? (
                <Stack horizontal={true} horizontalAlign="start" styles={stackStyles} className={styles.ReadOnlyStack} wrap tokens={numericalSpacingStackTokens}>
                    <StackItem hidden={!isView} className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.requestForInfoIntAssessNo}</Label>
                        <TextField disabled={true} value={personOfInterest.CaInternalAssessmentNo} />
                    </StackItem>
                    <StackItem hidden={!isView} className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.requestForInfoPOIAssessDate}</Label>
                        <TextField disabled={true} value={personOfInterest.DateOfAssessment} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.typeLabel}</Label>
                        <TextField disabled={true} value={personOfInterest.PersonType} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.legalNameLabel}</Label>
                        <TextField disabled={true} value={personOfInterest.LegalName} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.requestForInfoPOIAlsoKnownAs}</Label>
                        <TextField disabled={true} value={personOfInterest.AlsoKnownAs} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.leiRegistrationNumberLabel}</Label>
                        <TextField disabled={true} value={personOfInterest.LeiRegistration} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.countryOfIncorporationLabel}</Label>
                        <TextField disabled={true} value={personOfInterest?.CountryInc} className={styles.DisabledTextField}/>
                    </StackItem>
                </Stack>
            ) : (
                <Stack horizontal={true} horizontalAlign="start" styles={stackStyles} className={styles.ReadOnlyStack} wrap tokens={numericalSpacingStackTokens}>
                    <StackItem hidden={!isView} className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.requestForInfoIntAssessNo}</Label>
                        <TextField disabled={true} value={personOfInterest?.CaInternalAssessmentNo} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem hidden={!isView} className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.requestForInfoPOIAssessDate}</Label>
                        <TextField disabled={true} value={personOfInterest?.DateOfAssessment} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.typeLabel}</Label>
                        <TextField disabled={true} value={personOfInterest?.PersonType} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.newRequestForInfoPOIFName}</Label>
                        <TextField disabled={true} value={personOfInterest?.FirstName} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.newRequestForInfoPOILName}</Label>
                        <TextField disabled={true} value={personOfInterest?.LastName} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.alsoKnownAsLabel}</Label>
                        <TextField disabled={true} value={personOfInterest?.AlsoKnownAs} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.newRequestForInfoPOIBirthPlace}</Label>
                        <TextField disabled={true} value={placeOfBirth} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.newRequestForInfoPOIBirthDate}</Label>
                        <TextField className={styles.DisabledTextField} disabled={true} value={personOfInterest?.DateOfBirth} />
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.idLabel}</Label>
                        <TextField disabled={true} value={personOfInterest?.ID} className={styles.DisabledTextField}/>
                    </StackItem>
                    <StackItem className={styles.SearchStackItemSecondRow}>
                        <Label>{strings.socialSecurityNumberLabel}</Label>
                        <TextField disabled={true} value={personOfInterest?.SocialSecurityNumber} className={styles.DisabledTextField}/>
                    </StackItem>
                </Stack>
            )
            }
        </div>
    );
}

export default InitiatorPoiFieldsComponent;
